import React from 'react';
import Img from 'react-cool-img';
import Lock from 'spw-static/images/lock.svg';
import Close from 'spw-static/images/delete-input-icon.svg';
import { UnstyledReactLink } from 'spw-shared/globalComponents';
import {
  DialogBox,
  DialogCustom,
  GradientBackgroundContainer,
  LockoutFooterText,
  LockoutText,
  CloseButton,
} from '../styles';

const Lockout = () => {
  return (
    <GradientBackgroundContainer>
      <DialogBox error>
        <DialogCustom>
          <Img src={Lock} alt="lockout" className="icon-image" />
          <UnstyledReactLink to="/login">
            <CloseButton>
              <Img src={Close} alt="close" />
            </CloseButton>
          </UnstyledReactLink>
          <div className="title">ACCOUNT LOCKED</div>
          <LockoutText>
            You have maxed out your login attempts. Try again after five
            minutes.
          </LockoutText>
          <LockoutFooterText>
            Please email <strong> support@spaceplanwizard.com </strong>
            <br />
            if you need immediate assistance.
          </LockoutFooterText>
        </DialogCustom>
      </DialogBox>
    </GradientBackgroundContainer>
  );
};

export default Lockout;
